import React, { useContext } from "react";
import { DynamicContext } from "../../Context/DynamicContext";
import DarkMode from "../../Assets/Images/Dark-Mode.svg"
import LightMode from "../../Assets/Images/Light-Mode.svg"
import SystemDefault from "../../Assets/Images/System-Default-Mode.svg"
import "./Appearance.css";

function AppearancePage() {
  const { themePreference, setThemePreference } = useContext(DynamicContext);

  const handleThemeChange = (theme) => {
    setThemePreference(theme);
  };

  return (
    <div className="appearance-container">
      <div className="settings-title-container">
        <h2>Appearance</h2>
        <p>Change the appearance of VybogTAL according to your preference.</p>
      </div>

      <div className="theme-options-container">
        <div
          className={`theme-option ${
            themePreference === "system" ? "active" : ""
          }`}
          onClick={() => handleThemeChange("system")}
        >
          <img
            src={SystemDefault}
            alt="System Default"
            className="theme-image"
          />
          <span
            className={`theme-title-span ${
              themePreference === "system" ? "active" : ""
            }`}
          >
            System Default
          </span>
        </div>
        <div
          className={`theme-option ${
            themePreference === "light" ? "active" : ""
          }`}
          onClick={() => handleThemeChange("light")}
        >
          <img
            src={LightMode}
            alt="Light Mode"
            className="theme-image"
          />
          <span
            className={`theme-title-span ${
              themePreference === "light" ? "active" : ""
            }`}
          >
            Light Mode
          </span>
        </div>
        <div
          className={`theme-option ${themePreference === "dark" ? "active" : ""}`}
          onClick={() => handleThemeChange("dark")}
        >
          <img
            src={DarkMode}
            alt="Dark Mode"
            className="theme-image"
          />
          <span
            className={`theme-title-span ${
              themePreference === "dark" ? "active" : ""
            }`}
          >
            Dark Mode
          </span>
        </div>
      </div>
    </div>
  );
}

export default AppearancePage;